import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, FilterPipe } from '@prekog/common-ui';
import { Examination } from '../pricelist/examination';
import { GetSpecialitiesResponse } from './getspecialitiesresponse';
import { Speciality } from './speciality';

@Component({
    selector: 'app-specialities',
    templateUrl: './specialitypricelist.component.html',
    styleUrls: ['./specialitypricelist.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, RouterModule, FilterPipe, FormsModule]
})
export class SpecialityPriceListComponent implements OnInit {
    examinationList: Examination[] = [];
    getSpecialitiesUrl = '/regenero/get-all-specialities';

    regeneroBaseUrl = '';
    searchText = '';
    specialities?: Speciality[];

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }
    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.getSpecialities();
        }
    }

    getSpecialities() {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitiesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitiesUrl)
            .subscribe((response) => {
                this.specialities = response.specialityList;
            });
    }
}
